import { render, staticRenderFns } from "./modal-confirm-renew-shopping-bag.vue?vue&type=template&id=5f014a02&"
import script from "./modal-confirm-renew-shopping-bag.vue?vue&type=script&lang=js&"
export * from "./modal-confirm-renew-shopping-bag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports